module.exports = __webpack_public_path__ + "img/1F925.de68b192.svg";